import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { ModalVerErroresComponent } from 'src/app/views/shared/modal-ver-errores/modal-ver-errores.component';
import { RutService } from 'src/app/shared/services/rut.service';

@Component({
  selector: 'app-recepcion-pedidos-modal-result',
  templateUrl: './modal-result.component.html',
  styleUrls: ['../recepcion-pedidos.component.scss'],
})
export class RecepcionPedidosModalResultComponent implements OnInit {
  @ViewChild('verResultado', { static: true }) verPedidoModal: ModalDirective;
  @ViewChild(ModalVerErroresComponent, { static: true }) modalVerErrores: ModalVerErroresComponent;

  successDataAll: any[] = null;
  successData: any[] = null;
  paginationContextSuccess: PaginationContext = new PaginationContext();
  thereIsAtLeastOneOk: boolean = false;
  sumMontoNeto: number = null;
  sumMontoBruto: number = null;

  // Utils
  private log: any;
  listErrores: any[] = [];

  constructor(private clog: ConsoleService, public router: Router, private _rutService: RutService) {
    this.log = this.clog.log('MODAL-VER-RESULTADO');
  }

  ngOnInit() {
    this.paginationContextSuccess.RecordsByPage = 10;
  }

  show(successData) {
    this.successDataAll = successData;
    // successData.forEach((item) => {
    //   this.listErrores.push(...item.logErrores);
    // });
    // this.showErrores(this.listErrores);
    this.successDataAll.forEach((record) => {
      record.cabecera.rutFormato = this._rutService.AgregarDV(record.cabecera.direccion_cliente_rut);
    });

    this.thereIsAtLeastOneOk = this.successDataAll.filter((p) => p.pedidoConvertido).length > 0;
    this.log(
      'thereIsAtLeastOneOk',
      this.thereIsAtLeastOneOk,
      this.successDataAll,
      this.successDataAll.map((p) => ({ pedidoConvertido: p.pedidoConvertido }))
    );

    this.paginationContextSuccess.RecordsCount = this.successDataAll.length; //totalRegistros
    this.paginationContextSuccess.PagesCount = Math.ceil(this.paginationContextSuccess.RecordsCount / this.paginationContextSuccess.RecordsByPage); //totalPaginas
    this.paginationContextSuccess.CurrentPage = 1;

    const sumallNeto = this.successDataAll.map((item) => item.cabecera.total).reduce((prev, curr) => prev + curr, 0);
    const sumallBruto = this.successDataAll.map((item) => item.cabecera.totalBruto).reduce((prev, curr) => prev + curr, 0);

    this.sumMontoNeto = sumallNeto;
    this.sumMontoBruto = sumallBruto;
    this.showPageSuccess(1);

    this.verPedidoModal.show();
  }

  showPageSuccess(pageNumber: number) {
    this.paginationContextSuccess.CurrentPage = pageNumber;
    const start = (this.paginationContextSuccess.CurrentPage - 1) * this.paginationContextSuccess.RecordsByPage;
    this.successData = _.slice(this.successDataAll, start, start + this.paginationContextSuccess.RecordsByPage);
  }

  onPageChangeSuccess(context: PaginationContext) {
    this.showPageSuccess(context.RequestedPage);
  }

  navigateToAnalisisDeDemanda() {
    this.router.navigate(['./facturacion/analisisDemanda']);
  }

  showErrores(listaErrores) {
    this.modalVerErrores.loadAndShow(listaErrores);
  }
}
